// @flow

import React from 'react'
import FooterBottom from './FooterBottom'
import FooterExternal from './FooterExternal'

type PropTypes = {
  hasFooter?: boolean,
}

export default function Footer(props: PropTypes) {
  if (!props.hasFooter) {
    return null
  }

  return (
    <footer>
      <FooterExternal />
      <FooterBottom />
    </footer>
  )
}

Footer.defaultProps = {
  hasFooter: true,
}
